import React from 'react'
import About from '../Component/About'
import AboutBreadcrumb from '../Component/AboutBreadcrumb'
import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Testimonials from '../Component/Testimonials'
import Blog from '../Component/Blog'
import EducationSection from '../Component/EducationSection'
function Aboutpage() {
    return (
        <div>
            <Header />
            <AboutBreadcrumb />
            <About />
            <EducationSection />
            <Testimonials />
            <Blog />
            <Footer />
        </div>
    )
}

export default Aboutpage